import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(sessionStorage.getItem('token') || null);
  const [role, setRole] = useState(null);
  const [userId, setUserId] = useState(null);

  // Rolle und User-ID aus dem Token extrahieren
  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const userRole = decodedToken.role || decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        setRole(userRole);

        const userIdFromToken = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
        setUserId(userIdFromToken ? parseInt(userIdFromToken, 10) : null);

        setIsAuthenticated(true);
      } catch (error) {
        console.error('Fehler beim Decodieren des Tokens:', error);
        setIsAuthenticated(false);
        setRole(null);
        setUserId(null);
      }
    } else {
      setIsAuthenticated(false);
      setRole(null);
      setUserId(null);
    }
  }, [token]);

  // Event-Listener für beforeunload (Seite wird neu geladen oder Tab geschlossen)
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem('token');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const login = (newToken) => {
    sessionStorage.setItem('token', newToken);
    setToken(newToken);
    try {
      const decodedToken = jwtDecode(newToken);
      const userRole = decodedToken.role || decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      setRole(userRole);

      const userIdFromToken = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
      setUserId(userIdFromToken ? parseInt(userIdFromToken, 10) : null);

      setIsAuthenticated(true);
    } catch (error) {
      console.error('Fehler beim Decodieren des Tokens:', error);
      setIsAuthenticated(false);
      setRole(null);
      setUserId(null);
    }
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    setToken(null);
    setRole(null);
    setUserId(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, role, userId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);